exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wrap-name[data-v-320f27d9]{display:flex;flex:1}.wrap-name[data-v-320f27d9],.wrap-name .intv-name[data-v-320f27d9]{white-space:nowrap;overflow:hidden}.wrap-name .intv-name[data-v-320f27d9]{text-overflow:ellipsis}.disabledBg[data-v-320f27d9]{background-color:#fff}", ""]);

// exports
